<template>
  <div class="cloud-notice">
    <i class="el-icon-message-solid" v-popover:notice />
		<span v-show="total>0" class="unread"></span>
    <el-popover 
			popper-class="popover" 
			trigger="hover" 
			ref="notice" 
			width="360"
			placement="bottom-start"
			@show='getNotice'
			>
			<div v-if="!messages.length" class="no-messages">
				<span>暂无消息哦！</span>
			</div>
			<div v-else>
				<div class="title">消息通知</div>
				<div 
					v-for="item in messages" 
					:key="item.index" 
					:class="['content', {'important': item.isImportant}]"
					@click="checkMore"
					>
					<div class="flex">
						<span class="notice-title">{{item.title}}</span>
						<span class="datetime">{{item.created_at}}</span>
					</div>
					<p class="notice-content">{{item.content}}</p>
				</div>
			</div>
			<div class="more">
				<span class="to-more" @click="checkMore">查看更多</span>
			</div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "Notice",
	props: ['total'],
  data() {
    return {
			messages: []
    };
	},
  methods: {
		//获取消息悬浮框消息列表
		getNotice() {
			this.$ax('/api/auth/v1/msg/preview',{
				headers: {
					Authorization: localStorage.getItem("token")
				}
			})
			.then(res => {
				this.messages = res.data.messages
			})
			.catch(error => {console.log(error)})
		},
		//查看更多
		checkMore() {
			location.href = `/usercenter#/station-letter`;
		}
	}
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
  justify-content: space-between;
}

.cloud-notice {
	padding-right: 30px;
	position: relative;
	line-height: 37px;
	.el-icon-message-solid {
		background-color: #f5f5f5;
    padding: 7px;
    border-radius: 17px;
	}
	.popover {
		margin-top: 16px;
	}
}
.unread {
	content: '';
	width: 6px;
	height: 6px;
	border-radius: 6px;
	background-color: #f00;
	position: absolute;
	right: 29px;
	top: 6px;
}

.no-messages {
	text-align: center;
	padding: 16px 20px;
	font-size: 14px;
}

.title {
  padding-left: 20px;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  color: #222;
}
.content {
  padding: 16px 20px;
	border-top: 1px solid #f5f5f5;
	color: #222;
	cursor: pointer;
	.notice-title {
		width: 114px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;
	}
	.datetime {
		color: #999;
	}
	.notice-content {
		width: 320px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
.important {
	color: #222;
	font-weight: bold;
	.datetime {
		font-weight: normal;
	}
}
.more {
	text-align: center;
	color: #f70;
	background-color: #f5f5f5;
	height: 40px;
	line-height: 40px;
	.to-more {
		cursor: pointer;
	}
	.to-more::after {
		content: ">>";
		margin-left: 2px;
		font-size: 6px;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/notice.vue